import type {
  UmpireLevel,
  UmpirePosition,
  UmpireSettings,
  UmpireType
} from './umpires'

export interface UmpireAssignment {
  userId: string
  name: string
  /** The account's display name, shown when the assignment is opened. */
  displayName: string
  assignedBy: string
  canRemove: boolean
  teams?: Array<{ id: string; name: string }>
}
export interface UmpireConflict {
  userId: string
  name: string
  activity: 'playing' | 'already umpiring'
  gameId: string
  time: string
  closeness: string
}
export interface UmpireChoice {
  userId: string
  name: string
  reason: string | null
}
export interface UmpireGameRow {
  id: string
  seasonId: string
  seasonName: string
  levelId: string
  levelName: string
  startAt: string
  endAt: string | null
  timezone: string
  date: string
  status: 'scheduled' | 'inProgress' | 'final' | 'cancelled'
  home: string
  away: string
  homeTeamId?: string
  awayTeamId?: string
  location?: string
  venue: string
  /** The registry field the game is on. Blank when the game has none. */
  field: string
  notes: string
  umpireNotes: Record<string, string>
  positions: UmpirePosition[]
  assignments: Record<string, UmpireAssignment>
  conflicts: UmpireConflict[]
  choices: Record<string, UmpireChoice[]>
}
export interface UmpireSchedule {
  settings: UmpireSettings
  levels: UmpireLevel[]
  types: UmpireType[]
  noteTypes: UmpireLevel[]
  games: UmpireGameRow[]
  creditTeams: Array<{ id: string; name: string }>
  viewerId: string
  isAdmin: boolean
  view: 'umpire' | 'league' | 'schedule'
}
export interface UmpireLeague {
  id: string
  name: string
  logoUrl: string | null
}
export interface UmpireGameBlock {
  positions: Array<
    UmpirePosition & {
      person: { userId: string; name: string; avatarUrl?: string | null } | null
    }
  >
}
export interface UmpireRank {
  userId: string
  name: string
  count: number
  symbol: string
}
export interface UmpireLeaderboard {
  completed: UmpireRank[]
  scheduled: UmpireRank[]
  teams: Array<{ id: string; name: string; count: number }> | null
  page?: {
    order: 'asc' | 'desc'
    limit: number
    offset: number
    total: number
  }
}
/** The most people one read of the leaderboard's pages returns. */
export const UMPIRE_LEADERBOARD_MAX_PAGE = 50
export interface UmpireLeaderboardQuery {
  order?: 'asc' | 'desc'
  limit?: number
  offset?: number
}
export const UMPIRE_RANK_SYMBOLS = [
  '🏆',
  '🥈',
  '🥉',
  '⭐⭐⭐⭐⭐',
  '⭐⭐⭐⭐',
  '⭐⭐⭐',
  '⭐⭐',
  '⭐',
  '👍',
  '👌'
]
